import React from 'react'
import FAQList from './FAQList'
import '../../styles/FAQSection/FAQSection.scss'
import DesktopImg from '../../static/images/desktop.png'

const FAQSection = () => {
  return (
        <>
            <div className="faq_image_container">
                <img
                    src={DesktopImg}
                    width={400}
                    height={160}
                    alt="FAQ"
                />
            </div>
            <FAQList />
        </>
  )
}

export default FAQSection
